import { render } from "./NewbornModal.vue?vue&type=template&id=29b308c4&scoped=true"
import script from "./NewbornModal.vue?vue&type=script&lang=js"
export * from "./NewbornModal.vue?vue&type=script&lang=js"

import "./NewbornModal.vue?vue&type=style&index=0&id=29b308c4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b308c4"]])

export default __exports__